import Button from '@/components/elements/Button.vue';
import Badge from '@/components/elements/Badge.vue';

export default {
  install(app) {
    app.component('Button', Button);
    app.component('Badge', Badge);
  },
};
